import axios from "axios";
import { useState, useEffect } from "react";

const UnsettledClaim = () => {
  const [unsettledClaimData, setUnsettledClaim] = useState([]);
  const [loading, setLoading] = useState(false);

  const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;

  const url = `${rupali_api_url}/Api/WebSite/UnsettledClaim`;

  useEffect(() => {
    axios.get(url).then((res) => {
      setUnsettledClaim(res.data.data);
      setLoading(true);
    });
  }, []);

  return [unsettledClaimData, setUnsettledClaim, loading];
};

export default UnsettledClaim;
